import { QueryParamsHandler, StringParamParser } from '@servicetitan/react-hooks';

export type PartitionsQueryParams = Partial<{
    page: number;
    search: string;
    sortField: string;
    isAscending: boolean;
}>;

const pageParser: StringParamParser<number> = {
    stringify(value) {
        return value > 1 ? value.toString() : undefined;
    },
    parse(query) {
        const value = parseInt(query, 10);

        return Number.isNaN(value) || value <= 1 ? undefined : value;
    },
};

export const partitionsQueryParamsHandler = new QueryParamsHandler<PartitionsQueryParams>({
    search: QueryParamsHandler.parserString,
    sortField: QueryParamsHandler.parserString,
    isAscending: QueryParamsHandler.parserBoolean,
    page: QueryParamsHandler.querySingleParam(pageParser),
});
